<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <table class="c-indicator c-indicator-w-100">
      <thead>
        <tr>
          <th class="tab-wid-80">№<br /></th>
          <th class="tab-wid-250">
            Наименование закупаемых лицензий и патентов, ноу-хау
          </th>
          <th class="tab-wid-250">Количество</th>
          <th class="tab-wid-80"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in $parent.project
            .EQUIPMENT_LICENSES_PATENTS_ECOLOGY.items"
        >
          <td class="tab-wid-80">{{ index + 1 }}</td>
          <td class="tab-wid-80">{{ item.UF_NAME }}</td>
          <td class="tab-wid-80">
            <span v-if="item.UF_COUNT_FROM !== item.UF_COUNT_TO"
              >от {{ item.UF_COUNT_FROM }} до {{ item.UF_COUNT_TO }}</span
            >
            <span v-else>{{ item.UF_COUNT_FROM }}</span>
          </td>
          <td
            v-if="
              !$parent.$parent.projectDisabled &&
                !$parent.project.UF_IS_BLOCK &&
                $parent.project.UF_SETTING.IS_EQUIPMENT_ACCEPT !== 1
            "
          >
            <i class="i-edit centerIcon" @click="editItem(index)"></i>
            <i
              class="i-delete centerIcon"
              title="Удалить запись"
              @click="deleteItem(index)"
            ></i>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <div
      class="add-row"
      v-show="
        !$parent.$parent.projectDisabled &&
          !$parent.project.UF_IS_BLOCK &&
          $parent.project.UF_SETTING.IS_EQUIPMENT_ACCEPT !== 1
      "
    >
      <a class="link-add-row" @click="showAddItem">Добавить</a>
    </div>
    <div
      class="modal fade in"
      v-bind:class="{ show: showForm }"
      tabindex="-1"
      role="dialog"
    >
      <form v-on:submit.prevent="submit">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                @click="showForm = false"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Добавить позицию</h4>
            </div>
            <div class="modal-body">
              <div
                class="form-group"
                v-bind:class="{ 'has-error': checkError('UF_NAME') }"
              >
                <label
                  >Наименование закупаемых лицензий и патентов, ноу-хау<span
                    >*</span
                  ></label
                >
                <input
                  type="text"
                  class="form-control"
                  v-model="item.UF_NAME"
                  maxlength="200"
                />
              </div>
              <div
                class="form-group"
                v-bind:class="{ 'has-error': checkError('UF_COUNT_FROM') }"
              >
                <label>Количество<span>*</span></label>
                <div class="clear"></div>
                <input
                  type="text"
                  placeholder="от"
                  style="display: inline;width: auto"
                  class="form-control"
                  v-model="item.UF_COUNT_FROM"
                  @keypress="isNumber($event)"
                />
                <input
                  type="text"
                  placeholder="до"
                  style="display: inline;width: auto"
                  class="form-control"
                  v-model="item.UF_COUNT_TO"
                  @keypress="isNumber($event)"
                />
              </div>
              <button type="button" @click="submit" class="btn btn-info">
                Сохранить
              </button>
              <button
                type="button"
                @click="showForm = false"
                class="btn btn-default btn-style-big"
              >
                Отмена
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "EquipmentLicensesPatentsEcology",
  data() {
    return {
      showForm: false,
      editIndex: -1,
      item: {},
      errorFields: {}
    };
  },
  methods: {
    showAddItem() {
      this.setError("");
      this.showForm = true;
      this.editIndex = -1;
      this.item = {};
    },
    editItem(index) {
      this.setError("");
      this.editIndex = index;
      this.item = JSON.parse(
        JSON.stringify(
          this.$parent.project.EQUIPMENT_LICENSES_PATENTS_ECOLOGY.items[index]
        )
      );
      this.showForm = true;
    },
    deleteItem(index) {
      this.$parent.project.EQUIPMENT_LICENSES_PATENTS_ECOLOGY.items.splice(
        index,
        1
      );
    },
    submit() {
      this.setError("");
      if (!this.item.UF_NAME) {
        this.setError("UF_NAME");
      }
      if (
        !this.item.UF_COUNT_FROM ||
        !this.item.UF_COUNT_TO ||
        parseFloat(this.item.UF_COUNT_FROM) > parseFloat(this.item.UF_COUNT_TO)
      ) {
        this.setError("UF_COUNT_FROM");
      }
      if (Object.keys(this.errorFields).length) {
        return;
      }
      if (this.editIndex > -1) {
        this.$parent.project.EQUIPMENT_LICENSES_PATENTS_ECOLOGY.items[
          this.editIndex
        ] = JSON.parse(JSON.stringify(this.item));
      } else {
        this.$parent.project.EQUIPMENT_LICENSES_PATENTS_ECOLOGY.items.push(
          this.item
        );
      }
      this.showForm = false;
      return false;
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    setError(field, val) {
      if (!field) {
        this.errorFields = {};
        return;
      }
      this.errorFields[field] = val ? val : true;
    },
    checkError(field) {
      if (this.errorFields[field]) {
        return true;
      }
      return false;
    },
    countEntChar(value, limit) {
      if (value) {
        return value.length > limit ? 0 : limit - value.length;
      }
      return limit;
    }
  }
};
</script>

<style scoped></style>
